import React, { useEffect } from 'react';
import { useAppStore } from '@/hooks/useAppStore';

export const NewRoomPage: React.FC = () => {
  const clientConfig = useAppStore((state) => state.clientConfig);
  const setRoomId = useAppStore((state) => state.setRoomId);
  const redirectToRoom = useAppStore(state => state.redirectToRoom);

  useEffect(() => {
    const isCustomClient = clientConfig && clientConfig.config.name !== "CHOTTO";

    if (isCustomClient) {
      //if custom client, create new room under that prefix
      setRoomId(clientConfig.config.roomPrefix || "");
      redirectToRoom(clientConfig.config.roomPrefix || "");
    } else {
      //otherwise redirect to a new general room
      redirectToRoom("new");
    }
  }, []);

  return (
    <div
      className={"flex items-center justify-center p-0 chat-container fixed inset-0"}
    >
      Redirecting to a new room [{clientConfig?.config.roomPrefix}XXX] ...
    </div>
  );
};

export default NewRoomPage;
